import { isSafety } from "../../../utils/context-utils";
import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";
import DriveEndType from "../../../enums/drive-end-type";

export default class Safety extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Safety &&
            isSafety(play, fragment, gameContext)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.setIsSafety(true);
        ruleContext.setResetField(true);
        gameContext.setDriveContext({
            ...gameContext.getDriveContext(),
            previousDriveEndType: DriveEndType.Safety
        });

        return [];
    }
}
